import type { ReactNode } from 'react';
import { TitleSparks } from '../doodles/Doodles.js';

interface DesktopTopbarProps {
  /** Título manuscrito grande (ej. "Hola, Luis"). Opcional: sin título (ni
   *  kicker) el topbar muestra sólo `leading` + `trailing`. */
  title?: string;
  /** Antetítulo en mono mayúsculas (ej. "MIÉRCOLES · 14 DE MAYO"). Opcional. */
  kicker?: string;
  /**
   * Slot a la izquierda del kicker/título (p.ej. el anillo de nivel). El topbar
   * sigue presentacional; quien decide qué mostrar es la pantalla que lo monta.
   */
  leading?: ReactNode;
  /**
   * Slot a la derecha (p.ej. `<WalletButton />`). Mantenemos el topbar
   * presentacional; quien decide qué mostrar es la pantalla que lo monta.
   */
  trailing?: ReactNode;
}

/**
 * Barra superior del layout de escritorio: kicker + título manuscrito a la
 * izquierda, [trailing] a la derecha. El buscador "⌘K" y la campana de
 * notificaciones se quitaron a propósito: eran decorativos (sin backend de
 * búsqueda ni sistema de notificaciones) y prometían features inexistentes.
 * Vuelven cuando exista la funcionalidad real.
 */
export function DesktopTopbar({ title, kicker, leading, trailing }: DesktopTopbarProps) {
  const hasHeading = Boolean(title) || Boolean(kicker);
  return (
    <div className="dt-topbar">
      <div className="dt-topbar__lead">
        {leading}
        {hasHeading && (
          <div>
            {kicker && <div className="dt-topbar__kicker">{kicker}</div>}
            <div className="dt-topbar__title-wrap">
              <span className="script dt-topbar__title">{title}</span>
              <TitleSparks
                color="var(--lime)"
                size={22}
                style={{ position: 'absolute', top: -10, right: -26 }}
              />
            </div>
          </div>
        )}
      </div>
      {trailing && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>{trailing}</div>
      )}
    </div>
  );
}
